import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Lock, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-900 text-slate-300" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2">
            <img src="/shande-logo.png" alt="Shande III logo" className="h-12 w-12 rounded-full object-contain" />
            <span className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
              Shande <span className="text-sky-400">III</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-slate-400">
            The first and only charter boat out of Exmouth licensed to fish for giant bluefin tuna on a
            catch-and-release licence.
          </p>
          <a href="https://www.facebook.com/share/1TQ34JFFoY/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"
            data-testid="footer-facebook"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-slate-700 px-4 py-2 text-sm font-medium text-slate-300 transition-colors hover:border-sky-400 hover:text-sky-400">
            <Facebook className="h-4 w-4" /> Follow us on Facebook
          </a>
        </div>
        <div>
          <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">Find Us</h3>
          <p className="mt-4 flex items-center gap-2 text-sm">
            <MapPin className="h-4 w-4 text-sky-400" /> Exmouth Marina, Exmouth, Devon
          </p>
          <a href="tel:+447929834128" data-testid="footer-phone" className="mt-2 flex items-center gap-2 text-sm transition-colors hover:text-sky-400">
            <Phone className="h-4 w-4 text-sky-400" /> 07929 834128
          </a>
          <a href="mailto:shandefishingltd@gmail.com" data-testid="footer-email" className="mt-2 flex items-center gap-2 text-sm transition-colors hover:text-sky-400">
            <Mail className="h-4 w-4 text-sky-400" /> shandefishingltd@gmail.com
          </a>
        </div>
        <div>
          <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">Trips</h3>
          <ul className="mt-4 space-y-2 text-sm text-slate-400">
            <li>Giant Bluefin Tuna — 10hr, from £350</li>
            <li>Deep Sea Wrecking — £130pp</li>
            <li>Bream Fishing — £130pp</li>
            <li>Mackerel — 90 mins, £40pp</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Shande III Charters, Exmouth. All trips subject to weather.
        <Link to="/admin/login" data-testid="footer-skipper-login"
          className="ml-4 inline-flex items-center gap-1 font-medium text-slate-400 transition-colors hover:text-sky-400">
          <Lock className="h-3 w-3" /> Skipper Login
        </Link>
      </div>
    </footer>
  );
}
